export const FILTERS_ORDER_SETTINGS_KEY = "modulesFiltersOrder";
